import React, { useEffect, useState } from "react";
import { Logo } from "./Logo";

const navItems = [
  { label: "Pflegebox", href: "#was-ist" },
  { label: "Inhalte", href: "#inhalte" },
  { label: "Voraussetzungen", href: "#voraussetzungen" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "FAQ", href: "#faq" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAFAF7]/80 backdrop-blur-xl border-b border-[#1A1A1F]/[0.08]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => goTo(e, "#top")}
          data-testid="header-logo-link"
          className="flex items-center"
        >
          <Logo height={26} />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={(e) => goTo(e, n.href)}
              data-testid={`nav-link-${n.href.replace("#", "")}`}
              className="text-sm text-[#5A5F66] hover:text-[#1A1A1F] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#kontakt"
          onClick={(e) => goTo(e, "#kontakt")}
          data-testid="header-cta-button"
          className="inline-flex items-center text-sm font-medium px-5 py-2.5 rounded-full bg-[#3FA66D] text-white hover:bg-[#368F5E] transition-transform hover:scale-[1.03] shadow-[0_6px_20px_rgba(63,166,109,0.28)]"
        >
          Gratis bestellen
        </a>
      </div>
    </header>
  );
};

export default Header;
